/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

var NetworkStatus, getConfigParameter, logping, log, OutBuffer, triggerAuthentication, $;
if (typeof require === "function") {
	var storage = require("../utils/Storage");
	getStorageObject = storage.getStorageObject;
	setStorageObject = storage.setStorageObject;

	var logging = require("../utils/log");
	log = logging.log;
	logping = logging.logping;

	NetworkStatus = require("./NetworkStatus");
	OutBuffer = require("./OutBuffer");
	var c = require("../config");
	getConfigParameter = c.getConfigParameter;

  var auth = require("@/auth/OAuth2AuthorizationCode");
  triggerAuthentication = auth.triggerAuthentication;

	$ = require("jquery")
}

/**
 * The connection bundling the plain websocket handling
 * @type {{connect, sendMessage, close}}
 */
function PollConnection(serverUrl, connectionId, persistentContributionQueue, communication) {
// todo PET den gemeinsamen Code in eine Basis-Klasse raus ziehen ........!! (Wie geht das vernünftig ohne ES6/TS?)
	var self = this;

	/** the websocket URL to connect to; if undefined or null reconnect() will fail */
	var url;

	/** current status of the network communication: 0 - OK, 1 - Warning, 2 - Offline */
	var networkStatus = NetworkStatus.DISCONNECTED;

	// message handling
	var outBuffer = new OutBuffer(communication);
	var lastReceivedId = -1;
	var serverLastAckedId = -1;
	var ackRequired = false;
	var lastMessageReceivedTimestamp = -1;
	var lastPollStartedTimestamp = -1;
	var lastNetworkLatency = -1;
	var closing = false;
	var pollTimer = null;
	var pollIntervalMin = getConfigParameter("pollIntervalMin");
	var pollIntervalMax = getConfigParameter("pollIntervalMax");
	var pollTimeout = getConfigParameter("pollTimeout");
	var offlineTimeout = getConfigParameter("networkOfflineTimeout");
	var compressionEnabled = getConfigParameter("compressPayload");
	var accessToken = null;

	// --------------------------------- Websocket Connect ---------------------------------

	/**
	 * establish polling to the URL specified
	 * @param token the optional accessToken if authenticated via OAuth
	 */
	function connect(token) {
		if (!serverUrl) {
			notifyProgrammingError(
					"PollConnection.connect called without url passed and without previous url specified.");
			return;
		}
		if (token) {
			accessToken = token
		}
		var params = {id: connectionId};
		if (compressionEnabled) { params.c = true; }
		url = serverUrl + "/poll?" + $.param(params);
		if (getConfigParameter("secureCommunication") && url.startsWith("http:")) { url = "https:" + url.substr(5); }
		log.info("CONNECT: Starting PollConnection at url: ", url);
		closing = false; // start polling again
		app.manager.trigger("communication:connectionEstablished");
		pollMessages();
	}

	// --------------------------------- Poll messages ---------------------------------

	/**
	 * pollMessages is called repeatedly by writer-"thread"
	 */
	function pollMessages() {
		pollTimer = null; // poll timer has fired, so it can be removed again
		// first check for server timeout if we must go offline
		var now = Date.now();
		logping.trace(">>> pollMessages...", lastMessageReceivedTimestamp, " / ", now, " / ",
		              (now - lastMessageReceivedTimestamp));

		//log.trace("check to write messages in out buffer");
		var messagesToWrite = outBuffer.retrieveMessagesToWrite();
		var messages = _(messagesToWrite).map(function (message) {
			logping.debug(">>> Writing message #" + message.id + " (lastIn: ", lastReceivedId, ")");
			var msg = "{\"h\": \"" + lastReceivedId + "/" + message.id + "\",\"payload\":";
			if (compressionEnabled) {
				msg += "\"" + message.payload + "\"}";
			} else {
				msg += message.payload + "}";
			}
			return msg;
		});
		if (messages.length === 0 && ackRequired) {
			// send ack only
			// logping.debug("***** Writing ack: ", lastReceivedId);
			messages.push("{\"h\":" + lastReceivedId + "}");
			ackRequired = false;
		}

		lastPollStartedTimestamp = now; // used to calc the latency in handleIncomingMessages()
		// the messages are already json encoded, just wrap in array
    var postRequest = {
      url: url + (lastNetworkLatency >= 0 ? "&l=" + lastNetworkLatency : ""),
      type: "POST",
      headers: {},
      data: "[" + messages.join(",") + "]",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      timeout: pollTimeout,
      statusCode: {
        401: function(xhr) {
          handleAuthenticationFailure(xhr);
        }
      }
    }

		if (accessToken) {
	    postRequest.headers.Authorization = "Bearer " + accessToken
	  }

    $.ajax(postRequest)
      .done(handleIncomingMessages)
				.fail(handleNetworkFailure)
				.always(function () {
					if (!closing) {
						// and start the next poll cycle
						// when closing, stop polling
						// idea: increase pollIntervalMin here if we are offline to save battery (networkStatus === NetworkStatus.DISCONNECTED)
						var interval = Math.randomInt(pollIntervalMin, pollIntervalMax);
						// log.trace("next poll in ", interval, "ms");
						pollTimer = setTimeout(pollMessages, interval);
					}
				});
	}

	function handleAuthenticationFailure(xhr) {
		// ToDo: should auth always be triggered or only in special cases (e.g. when WWW-Authenticate header contains error="invalid_token")?
		triggerAuthentication();
	}

	function handleNetworkFailure() {
		logping.error("Poll failed");
		var now = Date.now();
		if ((now - lastMessageReceivedTimestamp) > offlineTimeout) {
			log.warn("Didn't receive a message from server for more than ", offlineTimeout,
			         "ms - going to reconnect: ", now, " - ", lastMessageReceivedTimestamp, " = ",
			         (now - lastMessageReceivedTimestamp));
			setNetworkStatus(NetworkStatus.DISCONNECTED);
			// we don't need to close the connection, we just keep polling (for now ... is this too battery consuming?)
		}
	}

	// --------------------------------- Incoming messages ---------------------------------

	function handleIncomingMessages(messages) {
		setNetworkStatus(NetworkStatus.CONNECTED); // set status to online
		lastMessageReceivedTimestamp = Date.now();
		// calc latency: Time from start of POST request to result received (divide by 2 to calc one-way only, #70948)
		lastNetworkLatency = Math.round((lastMessageReceivedTimestamp - lastPollStartedTimestamp) / 2);
		for (var i in messages) {
			// noinspection JSUnfilteredForInLoop
			onMessage(messages[i]);
		}
	}

	/**
	 * Called by underlying websocket implementation when messages are received
	 *
	 * @param transportMessage (object)
	 */
	// todo PET move MOST OF (!!) this to a common place for both connections
	function onMessage(transportMessage) {
		try {
			var header = parseHeader(transportMessage.h);

			if (serverLastAckedId < header.lastReceivedId) {
				// update the id of the last message the server has ack'ed
				serverLastAckedId = header.lastReceivedId;

				// remove acked messages from outBuffer
				outBuffer.removeAckedMessages(serverLastAckedId);

				// and also remove them from the persistent contribution queue
				persistentContributionQueue.removeAckedMessages(serverLastAckedId);
			}

			// connect to a "new" server-> forget everything we know
			if (header.lastReceivedId < 0) {
				// Initial ack from server received
				resetConnection(header);
			}

			if (transportMessage.payload) {
				if (header.messageId === lastReceivedId + 1) {
					// log.info("Received regular message: " + header.messageId);
					ackRequired = true;
					lastReceivedId++;
					var realMessage = transportMessage.payload;
					if (compressionEnabled) {
						var data, string;
						try {
							data = atob(realMessage);  // de-base64
							string = pako.inflate(data, {to: 'string'}); // inflate
							realMessage = JSON.parse(string);
						} catch (e) {
							communication.sendCommunicationErrorInfoMessage(
									"Client failed to parse compressed payload in message", e, header.messageId,
									(string ? string : transportMessage));
							return; // no message to handle
						}
					}
					logping.info("<<< Received message #" + header.messageId + ": ", JSON.stringify(realMessage),
					             " timestamp: ", lastMessageReceivedTimestamp);
					app.manager.safeTrigger("communication:messageReceived", realMessage);
				} else if (header.messageId <= lastReceivedId) {
					log.info("Ignoring incoming duplicate message with ID " + header.messageId);
					// pending #15873 maybe send info message to server about duplicated message to allow monitoring of network quality
				} else {
					log.warn("Messages got lost: expected " + (lastReceivedId + 1) + " but got " + header.messageId);
					// pending #15873 maybe send info message to server about lost message to allow monitoring of network quality
				}
			}
		} catch (e) {
			log.error("Error in onMessage: ", e.message, " - ", JSON.stringify(message), e); // JSON.stringify(message) does not encode all of the MessageEvent
		}
	}

	/**
	 * Parse the header, the format is: AckIdFromServer/IdOfReceivedMessage
	 * The "/IdOfReceivedMessage"-part is optional if just a high-level "ping"
	 * is received.
	 *
	 * @param header
	 * @returns {{lastReceivedId: Number, messageId: *}}
	 */
	// todo PET move this to a common place for both connections
	function parseHeader(header) {
		var parts = header.split("/");
		var lastReceivedId = parseInt(parts[0]);
		var messageId;
		if (parts.length > 1) {
			messageId = parseInt(parts[1]);
		}
		return {"lastReceivedId": lastReceivedId, "messageId": messageId};
	}

	/**
	 * resetConnection is called from onMessage() when
	 * the first message from the server is received (i.e. the initialAckTimeoutTimer is still running)
	 *
	 * When connecting to a "new" server (i.e. lastReceivedId === -1)
	 * the connection is reset.
	 */
	// todo PET move this to a common place for both connections
	function resetConnection() {
		log.info("Connected to new server-side connection - resetting connection and triggering ConnectMessage");
		outBuffer.clear();
		// the persistentContributionQueue is NOT cleared as these messages really should be resent
		lastReceivedId = -1;
		serverLastAckedId = -1;
		ackRequired = false;
		closing = false;

		setTimeout(function () { // wait a while before sending the ConnectMessage to (maybe) avoid app crashes on iPod touch with old app ...
			app.manager.trigger("communication:connectionEstablished");
		}, 17);
	}

	// --------------------------------- Sending messages ---------------------------------

	/**
	 * Stores the message as json string in the outBuffer waiting to be written by the write timer.
	 *
	 * @param message The message to be sent to the server.
	 */
	// todo PET move this to a common place for both connections
	function sendMessage(message) {
		var payload = JSON.stringify(message);
		var uncompressedPayload = payload;

		try {
			if (compressionEnabled) {
				var data = pako.deflate(payload, {to: 'string'}); // deflate
				payload = btoa(data);
			}
		} catch (e) {
			log.warn("Failed to deflate payload in send message: ", payload, e);
			return;
		}
		var msgId = outBuffer.addMessage(message.messageType, payload);
		persistentContributionQueue.storeMessage(msgId, message.messageType, uncompressedPayload);
	}

	// --------------------------------- Close & cleanup ---------------------------------

	/**
	 * close the connection
	 *
	 * calling this function will NOT try to reconnect / to reconnect connection
	 *
	 * Public (used by ServerCommunication)
	 */
	function close() {
		closing = true;
		log.debug("CLOSE: Closing connection");
		setNetworkStatus(NetworkStatus.DISCONNECTED);
		if (pollTimer) {
			clearTimeout(pollTimer);
			pollTimer = null;
		} // cancel running poll
		closing = false;
	}

	/**
	 * Sets the status of the server connection
	 * @param status 0 - OK, 1 - Warning, 2 - Error
	 */
	// todo PET move this to a common place for both connections
	function setNetworkStatus(/* NetworkStatus */ status) {
		if (networkStatus !== status) {
			log.info("Setting network status from ", networkStatus.name, " to ", status.name);
			networkStatus = status;
			setTimeout(function () {
				app.manager.safeTrigger("network:connectionStatus", status.code);
			}, 3);
		}
	}

	function getStatus() {
		return {
			url: url,
			networkStatus: networkStatus,
			outBuffer: outBuffer.getStatus(),
			lastReceivedId: lastReceivedId,
			ackRequired: ackRequired,
			self: self
		};
	}

	// Public API
	return {
		connect: connect,
		sendMessage: sendMessage,
		close: close,
		getStatus: getStatus // for debugging
	}
}

if (typeof module === "object") {
	module.exports = PollConnection;
}
